import naraPic from "@/public/images/artists/nara.png";
import { Artist } from "@/types/types";

export const nara = {
  id: "229",
  name: "Nara",
  image: naraPic,
  description: `Nara's voice is smooth and warm, with a rich tone that has natural depth and resonance. Her delivery is steady and melodic, blending Afrobeat rhythms with smooth, soulful phrasing.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnara-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Unprocessed", "Afrobeat", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
